import "./style.css";
import { useEffect } from "react";
import { useRequiredAccess } from "../../../hooks/useRequiredAccess";
import { ORG_TYPES } from "../../Common/Constants";
import {
  vannaBaseUrl,
} from "../../Common/endpoints";

export const getFirstLetter = (str) => {
  return str.charAt(0).toUpperCase();
};

const SpeakwithData = () => {
  const authToken = localStorage.getItem("authToken");
  // const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const checkAccess = useRequiredAccess(
    [],
    [ORG_TYPES.ADMINISTRATOR, ORG_TYPES.MANUFACTURER]
  );

  useEffect(() => {
    checkAccess();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {authToken ? (
        <iframe
          className="iframe-box"
          src={vannaBaseUrl}
          title="Vanna AI"
        ></iframe>
      ) : (
        <div>Not Logged In</div>
      )}
    </>
  );
};

export default SpeakwithData;
